var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrianglify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731,456L685,389L706,459Z",
    fill: "#7ec97b",
    stroke: "#7ec97b",
    strokeWidth: 1.51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M731,456L791,421L685,389Z",
    fill: "#7dc87a",
    stroke: "#7dc87a",
    strokeWidth: 1.51
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M791,421L750,283L685,389Z",
    fill: "#8ace7f",
    stroke: "#8ace7f",
    strokeWidth: 1.51
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M750,283L690,304L685,389Z",
    fill: "#97d385",
    stroke: "#97d385",
    strokeWidth: 1.51
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M685,389L605,478L706,459Z",
    fill: "#83cb7c",
    stroke: "#83cb7c",
    strokeWidth: 1.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M706,459L729,550L731,456Z",
    fill: "#6fc174",
    stroke: "#6fc174",
    strokeWidth: 1.51
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M583,394L605,478L685,389Z",
    fill: "#8ecf81",
    stroke: "#8ecf81",
    strokeWidth: 1.51
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M659,564L729,550L706,459Z",
    fill: "#6bbe71",
    stroke: "#6bbe71",
    strokeWidth: 1.51
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M731,456L836,473L791,421Z",
    fill: "#6fc174",
    stroke: "#6fc174",
    strokeWidth: 1.51
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M791,421L836,473L822,389Z",
    fill: "#70c273",
    stroke: "#70c273",
    strokeWidth: 1.51
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M609,310L583,394L685,389Z",
    fill: "#9bd586",
    stroke: "#9bd586",
    strokeWidth: 1.51
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M729,550L836,473L731,456Z",
    fill: "#68be70",
    stroke: "#68be70",
    strokeWidth: 1.51
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M822,389L750,283L791,421Z",
    fill: "#84ca7b",
    stroke: "#84ca7b",
    strokeWidth: 1.51
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M690,304L609,310L685,389Z",
    fill: "#9cd687",
    stroke: "#9cd687",
    strokeWidth: 1.51
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M704,253L609,310L690,304Z",
    fill: "#a4d98b",
    stroke: "#a4d98b",
    strokeWidth: 1.51
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M605,478L659,564L706,459Z",
    fill: "#77c476",
    stroke: "#77c476",
    strokeWidth: 1.51
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M822,389L864,349L750,283Z",
    fill: "#86ca7c",
    stroke: "#86ca7c",
    strokeWidth: 1.51
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M952,459L864,349L822,389Z",
    fill: "#6fbf71",
    stroke: "#6fbf71",
    strokeWidth: 1.51
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M750,283L704,253L690,304Z",
    fill: "#a0d789",
    stroke: "#a0d789",
    strokeWidth: 1.51
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M785,197L704,253L750,283Z",
    fill: "#a2d88a",
    stroke: "#a2d88a",
    strokeWidth: 1.51
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M609,310L531,355L583,394Z",
    fill: "#a5da8a",
    stroke: "#a5da8a",
    strokeWidth: 1.51
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M583,394L494,458L605,478Z",
    fill: "#91d183",
    stroke: "#91d183",
    strokeWidth: 1.51
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M569,246L531,355L609,310Z",
    fill: "#b0de8f",
    stroke: "#b0de8f",
    strokeWidth: 1.51
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M605,478L601,579L659,564Z",
    fill: "#73c173",
    stroke: "#73c173",
    strokeWidth: 1.51
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M833,670L864,553L729,550Z",
    fill: "#4dad60",
    stroke: "#4dad60",
    strokeWidth: 1.51
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M494,458L601,579L605,478Z",
    fill: "#83ca7b",
    stroke: "#83ca7b",
    strokeWidth: 1.51
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M729,550L864,553L836,473Z",
    fill: "#5ab668",
    stroke: "#5ab668",
    strokeWidth: 1.51
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M975,376L903,328L864,349Z",
    fill: "#76c173",
    stroke: "#76c173",
    strokeWidth: 1.51
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684,633L729,550L659,564Z",
    fill: "#61b76a",
    stroke: "#61b76a",
    strokeWidth: 1.51
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M864,349L810,211L750,283Z",
    fill: "#93d081",
    stroke: "#93d081",
    strokeWidth: 1.51
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M952,459L822,389L836,473Z",
    fill: "#65bb6e",
    stroke: "#65bb6e",
    strokeWidth: 1.51
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M601,579L684,633L659,564Z",
    fill: "#66b86b",
    stroke: "#66b86b",
    strokeWidth: 1.51
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M483,411L494,458L583,394Z",
    fill: "#9cd687",
    stroke: "#9cd687",
    strokeWidth: 1.51
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M704,253L569,246L609,310Z",
    fill: "#aedd8f",
    stroke: "#aedd8f",
    strokeWidth: 1.51
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M531,355L483,411L583,394Z",
    fill: "#a3d98a",
    stroke: "#a3d98a",
    strokeWidth: 1.51
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M903,328L810,211L864,349Z",
    fill: "#89cb7c",
    stroke: "#89cb7c",
    strokeWidth: 1.51
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M704,253L649,171L569,246Z",
    fill: "#b5e092",
    stroke: "#b5e092",
    strokeWidth: 1.51
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M450,340L483,411L531,355Z",
    fill: "#addd8e",
    stroke: "#addd8e",
    strokeWidth: 1.51
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M810,211L785,197L750,283Z",
    fill: "#a0d688",
    stroke: "#a0d688",
    strokeWidth: 1.51
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M864,553L952,459L836,473Z",
    fill: "#55b466",
    stroke: "#55b466",
    strokeWidth: 1.51
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M727,117L649,171L704,253Z",
    fill: "#b3df94",
    stroke: "#b3df94",
    strokeWidth: 1.51
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M864,553L900,598L952,459Z",
    fill: "#48ad5f",
    stroke: "#48ad5f",
    strokeWidth: 1.51
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M833,670L900,598L864,553Z",
    fill: "#41a55a",
    stroke: "#41a55a",
    strokeWidth: 1.51
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M903,328L957,209L810,211Z",
    fill: "#8fcc7e",
    stroke: "#8fcc7e",
    strokeWidth: 1.51
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M952,459L975,376L864,349Z",
    fill: "#6aba6e",
    stroke: "#6aba6e",
    strokeWidth: 1.51
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M569,246L518,239L531,355Z",
    fill: "#b9e293",
    stroke: "#b9e293",
    strokeWidth: 1.51
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M535,169L518,239L569,246Z",
    fill: "#c4e799",
    stroke: "#c4e799",
    strokeWidth: 1.51
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M494,458L499,613L601,579Z",
    fill: "#7fc677",
    stroke: "#7fc677",
    strokeWidth: 1.51
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M483,411L451,470L494,458Z",
    fill: "#9cd687",
    stroke: "#9cd687",
    strokeWidth: 1.51
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M399,385L451,470L483,411Z",
    fill: "#a5da8b",
    stroke: "#a5da8b",
    strokeWidth: 1.51
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M518,239L450,340L531,355Z",
    fill: "#b7e193",
    stroke: "#b7e193",
    strokeWidth: 1.51
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M780,699L833,670L729,550Z",
    fill: "#4ba65d",
    stroke: "#4ba65d",
    strokeWidth: 1.51
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M601,579L564,654L684,633Z",
    fill: "#67b469",
    stroke: "#67b469",
    strokeWidth: 1.51
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M684,633L780,699L729,550Z",
    fill: "#54ac62",
    stroke: "#54ac62",
    strokeWidth: 1.51
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M499,613L564,654L601,579Z",
    fill: "#72b96e",
    stroke: "#72b96e",
    strokeWidth: 1.51
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M975,376L988,334L903,328Z",
    fill: "#74bd70",
    stroke: "#74bd70",
    strokeWidth: 1.51
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1055,422L988,334L975,376Z",
    fill: "#69b469",
    stroke: "#69b469",
    strokeWidth: 1.51
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M770,772L780,699L654,778Z",
    fill: "#469a58",
    stroke: "#469a58",
    strokeWidth: 1.51
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M451,470L499,613L494,458Z",
    fill: "#8ccd7f",
    stroke: "#8ccd7f",
    strokeWidth: 1.51
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M785,197L727,117L704,253Z",
    fill: "#acdc90",
    stroke: "#acdc90",
    strokeWidth: 1.51
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M649,171L572,151L569,246Z",
    fill: "#c0e598",
    stroke: "#c0e598",
    strokeWidth: 1.51
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M820,93L727,117L785,197Z",
    fill: "#aedc91",
    stroke: "#aedc91",
    strokeWidth: 1.51
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M820,93L785,197L810,211Z",
    fill: "#a6d88c",
    stroke: "#a6d88c",
    strokeWidth: 1.51
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M518,239L450,224L450,340Z",
    fill: "#c3e798",
    stroke: "#c3e798",
    strokeWidth: 1.51
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M562,76L572,151L649,171Z",
    fill: "#c8e89e",
    stroke: "#c8e89e",
    strokeWidth: 1.51
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M572,151L535,169L569,246Z",
    fill: "#c6e89b",
    stroke: "#c6e89b",
    strokeWidth: 1.51
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M450,340L399,385L483,411Z",
    fill: "#b0de8f",
    stroke: "#b0de8f",
    strokeWidth: 1.51
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M434,600L481,645L499,613Z",
    fill: "#7cbd72",
    stroke: "#7cbd72",
    strokeWidth: 1.51
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M359,293L399,385L450,340Z",
    fill: "#bee596",
    stroke: "#bee596",
    strokeWidth: 1.51
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M988,334L957,209L903,328Z",
    fill: "#81c276",
    stroke: "#81c276",
    strokeWidth: 1.51
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M952,459L1055,422L975,376Z",
    fill: "#5fb167",
    stroke: "#5fb167",
    strokeWidth: 1.51
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M988,334L1027,235L957,209Z",
    fill: "#84c075",
    stroke: "#84c075",
    strokeWidth: 1.51
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1017,589L1028,495L952,459Z",
    fill: "#46a65c",
    stroke: "#46a65c",
    strokeWidth: 1.51
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1017,589L952,459L900,598Z",
    fill: "#41a65a",
    stroke: "#41a65a",
    strokeWidth: 1.51
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M499,613L481,645L564,654Z",
    fill: "#74b86e",
    stroke: "#74b86e",
    strokeWidth: 1.51
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M654,778L780,699L684,633Z",
    fill: "#4fa25d",
    stroke: "#4fa25d",
    strokeWidth: 1.51
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M434,600L499,613L451,470Z",
    fill: "#85c879",
    stroke: "#85c879",
    strokeWidth: 1.51
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M535,169L450,224L518,239Z",
    fill: "#caea9c",
    stroke: "#caea9c",
    strokeWidth: 1.51
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M361,563L434,600L451,470Z",
    fill: "#8fcd7e",
    stroke: "#8fcd7e",
    strokeWidth: 1.51
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M833,670L973,632L900,598Z",
    fill: "#389e54",
    stroke: "#389e54",
    strokeWidth: 1.51
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M911,751L973,632L833,670Z",
    fill: "#31964f",
    stroke: "#31964f",
    strokeWidth: 1.51
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M957,209L905,136L810,211Z",
    fill: "#99d084",
    stroke: "#99d084",
    strokeWidth: 1.51
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1028,495L1055,422L952,459Z",
    fill: "#53ab62",
    stroke: "#53ab62",
    strokeWidth: 1.51
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M872,110L820,93L810,211Z",
    fill: "#a7d78d",
    stroke: "#a7d78d",
    strokeWidth: 1.51
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M648,30L562,76L649,171Z",
    fill: "#c8e8a3",
    stroke: "#c8e8a3",
    strokeWidth: 1.51
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M905,136L872,110L810,211Z",
    fill: "#a1d589",
    stroke: "#a1d589",
    strokeWidth: 1.51
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M973,632L1017,589L900,598Z",
    fill: "#379c53",
    stroke: "#379c53",
    strokeWidth: 1.51
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1106,507L1106,420L1055,422Z",
    fill: "#50a45d",
    stroke: "#50a45d",
    strokeWidth: 1.51
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M654,778L684,633L601,769Z",
    fill: "#57a25e",
    stroke: "#57a25e",
    strokeWidth: 1.51
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M780,699L832,779L833,670Z",
    fill: "#3d9854",
    stroke: "#3d9854",
    strokeWidth: 1.51
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M957,209L986,110L905,136Z",
    fill: "#98cc82",
    stroke: "#98cc82",
    strokeWidth: 1.51
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1091,241L1027,235L988,334Z",
    fill: "#7ebb71",
    stroke: "#7ebb71",
    strokeWidth: 1.51
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M601,769L684,633L564,654Z",
    fill: "#60a963",
    stroke: "#60a963",
    strokeWidth: 1.51
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M529,757L564,654L481,645Z",
    fill: "#6daf68",
    stroke: "#6daf68",
    strokeWidth: 1.51
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M529,757L601,769L564,654Z",
    fill: "#64a863",
    stroke: "#64a863",
    strokeWidth: 1.51
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M535,169L423,162L450,224Z",
    fill: "#d1eca0",
    stroke: "#d1eca0",
    strokeWidth: 1.51
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M572,151L562,76L535,169Z",
    fill: "#cdeba0",
    stroke: "#cdeba0",
    strokeWidth: 1.51
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M648,30L649,171L727,117Z",
    fill: "#c0e49d",
    stroke: "#c0e49d",
    strokeWidth: 1.51
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M820,93L746,45L727,117Z",
    fill: "#b4de9a",
    stroke: "#b4de9a",
    strokeWidth: 1.51
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M863,-13L746,45L820,93Z",
    fill: "#b0dc9f",
    stroke: "#b0dc9f",
    strokeWidth: 1.51
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M450,224L359,293L450,340Z",
    fill: "#c6e89a",
    stroke: "#c6e89a",
    strokeWidth: 1.51
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M319,503L361,563L451,470Z",
    fill: "#9ad385",
    stroke: "#9ad385",
    strokeWidth: 1.51
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M343,230L359,293L450,224Z",
    fill: "#d2ed9f",
    stroke: "#d2ed9f",
    strokeWidth: 1.51
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M770,772L832,779L780,699Z",
    fill: "#3d9553",
    stroke: "#3d9553",
    strokeWidth: 1.51
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M973,632L1044,652L1017,589Z",
    fill: "#30944e",
    stroke: "#30944e",
    strokeWidth: 1.51
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M749,811L832,779L770,772Z",
    fill: "#3b9152",
    stroke: "#3b9152",
    strokeWidth: 1.51
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M429,742L529,757L481,645Z",
    fill: "#70ae68",
    stroke: "#70ae68",
    strokeWidth: 1.51
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M319,503L451,470L399,385Z",
    fill: "#a6d98c",
    stroke: "#a6d98c",
    strokeWidth: 1.51
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M406,679L481,645L434,600Z",
    fill: "#7dbb71",
    stroke: "#7dbb71",
    strokeWidth: 1.51
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M641,872L749,811L654,778Z",
    fill: "#499357",
    stroke: "#499357",
    strokeWidth: 1.51
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M832,779L911,751L833,670Z",
    fill: "#349250",
    stroke: "#349250",
    strokeWidth: 1.51
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M422,70L423,162L535,169Z",
    fill: "#d9f0a6",
    stroke: "#d9f0a6",
    strokeWidth: 1.51
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1055,422L1139,309L988,334Z",
    fill: "#6ab068",
    stroke: "#6ab068",
    strokeWidth: 1.51
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1106,507L1055,422L1028,495Z",
    fill: "#4ba45c",
    stroke: "#4ba45c",
    strokeWidth: 1.51
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M746,45L648,30L727,117Z",
    fill: "#bde3a2",
    stroke: "#bde3a2",
    strokeWidth: 1.51
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M654,778L749,811L770,772Z",
    fill: "#449556",
    stroke: "#449556",
    strokeWidth: 1.51
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M963,832L993,785L911,751Z",
    fill: "#208246",
    stroke: "#208246",
    strokeWidth: 1.51
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M586,808L654,778L601,769Z",
    fill: "#569d5d",
    stroke: "#569d5d",
    strokeWidth: 1.51
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M359,293L321,381L399,385Z",
    fill: "#c0e597",
    stroke: "#c0e597",
    strokeWidth: 1.51
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1017,589L1106,507L1028,495Z",
    fill: "#3e9e56",
    stroke: "#3e9e56",
    strokeWidth: 1.51
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1086,612L1106,507L1017,589Z",
    fill: "#32974f",
    stroke: "#32974f",
    strokeWidth: 1.51
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M361,671L406,679L434,600Z",
    fill: "#81bc72",
    stroke: "#81bc72",
    strokeWidth: 1.51
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M321,381L319,503L399,385Z",
    fill: "#b1df91",
    stroke: "#b1df91",
    strokeWidth: 1.51
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M361,563L361,671L434,600Z",
    fill: "#88c378",
    stroke: "#88c378",
    strokeWidth: 1.51
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M993,785L1044,652L973,632Z",
    fill: "#288a47",
    stroke: "#288a47",
    strokeWidth: 1.51
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M529,757L586,808L601,769Z",
    fill: "#5da05f",
    stroke: "#5da05f",
    strokeWidth: 1.51
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M468,821L586,808L529,757Z",
    fill: "#62a061",
    stroke: "#62a061",
    strokeWidth: 1.51
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1027,235L986,110L957,209Z",
    fill: "#90c57c",
    stroke: "#90c57c",
    strokeWidth: 1.51
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M905,136L966,30L872,110Z",
    fill: "#a1d38d",
    stroke: "#a1d38d",
    strokeWidth: 1.51
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M872,110L863,-13L820,93Z",
    fill: "#aad897",
    stroke: "#aad897",
    strokeWidth: 1.51
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1075,134L986,110L1027,235Z",
    fill: "#90c37b",
    stroke: "#90c37b",
    strokeWidth: 1.51
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M212,306L233,370L321,381Z",
    fill: "#c8e99d",
    stroke: "#c8e99d",
    strokeWidth: 1.51
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M423,162L343,230L450,224Z",
    fill: "#d6efa2",
    stroke: "#d6efa2",
    strokeWidth: 1.51
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1139,309L1091,241L988,334Z",
    fill: "#76b46c",
    stroke: "#76b46c",
    strokeWidth: 1.51
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1044,652L1086,612L1017,589Z",
    fill: "#2e914b",
    stroke: "#2e914b",
    strokeWidth: 1.51
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M562,76L422,70L535,169Z",
    fill: "#d7efa7",
    stroke: "#d7efa7",
    strokeWidth: 1.51
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M423,162L312,159L343,230Z",
    fill: "#dff2a7",
    stroke: "#dff2a7",
    strokeWidth: 1.51
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M611,-19L536,31L562,76Z",
    fill: "#d1ecb2",
    stroke: "#d1ecb2",
    strokeWidth: 1.51
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M406,679L429,742L481,645Z",
    fill: "#78b46d",
    stroke: "#78b46d",
    strokeWidth: 1.51
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M335,751L429,742L406,679Z",
    fill: "#7bb16d",
    stroke: "#7bb16d",
    strokeWidth: 1.51
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M278,700L361,671L361,563Z",
    fill: "#89c077",
    stroke: "#89c077",
    strokeWidth: 1.51
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1164,424L1139,309L1106,420Z",
    fill: "#5da661",
    stroke: "#5da661",
    strokeWidth: 1.51
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1106,420L1139,309L1055,422Z",
    fill: "#60aa63",
    stroke: "#60aa63",
    strokeWidth: 1.51
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M648,30L611,-19L562,76Z",
    fill: "#cce9b0",
    stroke: "#cce9b0",
    strokeWidth: 1.51
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M746,45L656,-27L648,30Z",
    fill: "#c2e5ad",
    stroke: "#c2e5ad",
    strokeWidth: 1.51
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M772,-52L656,-27L746,45Z",
    fill: "#bce2ae",
    stroke: "#bce2ae",
    strokeWidth: 1.51
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M656,-27L611,-19L648,30Z",
    fill: "#c9e8b3",
    stroke: "#c9e8b3",
    strokeWidth: 1.51
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1175,465L1164,424L1106,420Z",
    fill: "#4fa05c",
    stroke: "#4fa05c",
    strokeWidth: 1.51
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1175,465L1106,420L1106,507Z",
    fill: "#4a9f5a",
    stroke: "#4a9f5a",
    strokeWidth: 1.51
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M536,31L422,70L562,76Z",
    fill: "#d8efb0",
    stroke: "#d8efb0",
    strokeWidth: 1.51
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M496,-19L422,70L536,31Z",
    fill: "#dcf1b7",
    stroke: "#dcf1b7",
    strokeWidth: 1.51
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M966,30L863,-13L872,110Z",
    fill: "#a4d597",
    stroke: "#a4d597",
    strokeWidth: 1.51
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M586,808L641,872L654,778Z",
    fill: "#52965a",
    stroke: "#52965a",
    strokeWidth: 1.51
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M859,872L911,751L832,779Z",
    fill: "#2b894b",
    stroke: "#2b894b",
    strokeWidth: 1.51
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M552,891L641,872L586,808Z",
    fill: "#559259",
    stroke: "#559259",
    strokeWidth: 1.51
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M986,110L966,30L905,136Z",
    fill: "#9ece89",
    stroke: "#9ece89",
    strokeWidth: 1.51
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1091,241L1075,134L1027,235Z",
    fill: "#88bc74",
    stroke: "#88bc74",
    strokeWidth: 1.51
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1195,156L1075,134L1091,241Z",
    fill: "#87b974",
    stroke: "#87b974",
    strokeWidth: 1.51
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1044,652L1137,656L1086,612Z",
    fill: "#288946",
    stroke: "#288946",
    strokeWidth: 1.51
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M911,751L993,785L973,632Z",
    fill: "#288b49",
    stroke: "#288b49",
    strokeWidth: 1.51
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M859,872L832,779L749,811Z",
    fill: "#34894e",
    stroke: "#34894e",
    strokeWidth: 1.51
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1045,69L966,30L986,110Z",
    fill: "#9bc98a",
    stroke: "#9bc98a",
    strokeWidth: 1.51
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1164,424L1196,336L1139,309Z",
    fill: "#62a662",
    stroke: "#62a662",
    strokeWidth: 1.51
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1183,605L1175,465L1106,507Z",
    fill: "#389552",
    stroke: "#389552",
    strokeWidth: 1.51
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1183,605L1106,507L1086,612Z",
    fill: "#2e924d",
    stroke: "#2e924d",
    strokeWidth: 1.51
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M429,742L468,821L529,757Z",
    fill: "#6ba665",
    stroke: "#6ba665",
    strokeWidth: 1.51
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M454,843L468,821L429,742Z",
    fill: "#6ba364",
    stroke: "#6ba364",
    strokeWidth: 1.51
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M846,-79L772,-52L863,-13Z",
    fill: "#afdba5",
    stroke: "#afdba5",
    strokeWidth: 1.51
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M863,-13L772,-52L746,45Z",
    fill: "#b3dda8",
    stroke: "#b3dda8",
    strokeWidth: 1.51
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M598,-150L496,-19L611,-19Z",
    fill: "#d2ecb8",
    stroke: "#d2ecb8",
    strokeWidth: 1.51
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M735,948L859,872L749,811Z",
    fill: "#37824c",
    stroke: "#37824c",
    strokeWidth: 1.51
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M422,70L312,159L423,162Z",
    fill: "#e3f4aa",
    stroke: "#e3f4aa",
    strokeWidth: 1.51
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M212,306L321,381L359,293Z",
    fill: "#caea9d",
    stroke: "#caea9d",
    strokeWidth: 1.51
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M207,475L250,544L319,503Z",
    fill: "#a6d88c",
    stroke: "#a6d88c",
    strokeWidth: 1.51
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M319,503L250,544L361,563Z",
    fill: "#9bd285",
    stroke: "#9bd285",
    strokeWidth: 1.51
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M364,848L454,843L429,742Z",
    fill: "#6fa366",
    stroke: "#6fa366",
    strokeWidth: 1.51
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M207,475L319,503L321,381Z",
    fill: "#b0dd92",
    stroke: "#b0dd92",
    strokeWidth: 1.51
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1075,134L1045,69L986,110Z",
    fill: "#97c580",
    stroke: "#97c580",
    strokeWidth: 1.51
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M859,872L963,832L911,751Z",
    fill: "#238347",
    stroke: "#238347",
    strokeWidth: 1.51
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M242,238L359,293L343,230Z",
    fill: "#d8efa3",
    stroke: "#d8efa3",
    strokeWidth: 1.51
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1133,726L1137,656L1044,652Z",
    fill: "#218142",
    stroke: "#218142",
    strokeWidth: 1.51
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1133,726L1044,652L993,785Z",
    fill: "#1f8042",
    stroke: "#1f8042",
    strokeWidth: 1.51
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M422,70L311,36L312,159Z",
    fill: "#eaf7b3",
    stroke: "#eaf7b3",
    strokeWidth: 1.51
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M611,-19L496,-19L536,31Z",
    fill: "#d5eeb9",
    stroke: "#d5eeb9",
    strokeWidth: 1.51
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M645,-92L611,-19L656,-27Z",
    fill: "#c9e8b3",
    stroke: "#c9e8b3",
    strokeWidth: 1.51
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1139,309L1188,263L1091,241Z",
    fill: "#76b16b",
    stroke: "#76b16b",
    strokeWidth: 1.51
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1075,134L1107,29L1045,69Z",
    fill: "#94c083",
    stroke: "#94c083",
    strokeWidth: 1.51
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1287,436L1196,336L1164,424Z",
    fill: "#559f5d",
    stroke: "#559f5d",
    strokeWidth: 1.51
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M531,892L552,891L586,808Z",
    fill: "#5a935a",
    stroke: "#5a935a",
    strokeWidth: 1.51
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M335,751L406,679L361,671Z",
    fill: "#80b66f",
    stroke: "#80b66f",
    strokeWidth: 1.51
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1196,336L1188,263L1139,309Z",
    fill: "#6eab67",
    stroke: "#6eab67",
    strokeWidth: 1.51
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M641,872L735,948L749,811Z",
    fill: "#428751",
    stroke: "#428751",
    strokeWidth: 1.51
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M531,892L586,808L468,821Z",
    fill: "#5f985d",
    stroke: "#5f985d",
    strokeWidth: 1.51
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M966,30L940,-30L863,-13Z",
    fill: "#a3d39e",
    stroke: "#a3d39e",
    strokeWidth: 1.51
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M991,-24L940,-30L966,30Z",
    fill: "#a0ce9a",
    stroke: "#a0ce9a",
    strokeWidth: 1.51
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M278,700L335,751L361,671Z",
    fill: "#83b672",
    stroke: "#83b672",
    strokeWidth: 1.51
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1137,656L1183,605L1086,612Z",
    fill: "#268847",
    stroke: "#268847",
    strokeWidth: 1.51
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1175,465L1287,436L1164,424Z",
    fill: "#4a9b5a",
    stroke: "#4a9b5a",
    strokeWidth: 1.51
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M312,159L242,238L343,230Z",
    fill: "#e0f3a8",
    stroke: "#e0f3a8",
    strokeWidth: 1.51
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M454,843L531,892L468,821Z",
    fill: "#64995f",
    stroke: "#64995f",
    strokeWidth: 1.51
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M250,544L278,700L361,563Z",
    fill: "#92c87e",
    stroke: "#92c87e",
    strokeWidth: 1.51
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M233,370L207,475L321,381Z",
    fill: "#bce398",
    stroke: "#bce398",
    strokeWidth: 1.51
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M193,381L207,475L233,370Z",
    fill: "#c0e49b",
    stroke: "#c0e49b",
    strokeWidth: 1.51
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M242,238L212,306L359,293Z",
    fill: "#d6efa3",
    stroke: "#d6efa3",
    strokeWidth: 1.51
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M940,-30L846,-79L863,-13Z",
    fill: "#a8d7a1",
    stroke: "#a8d7a1",
    strokeWidth: 1.51
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M754,-98L645,-92L656,-27Z",
    fill: "#c2e5b0",
    stroke: "#c2e5b0",
    strokeWidth: 1.51
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M754,-98L656,-27L772,-52Z",
    fill: "#bce2ae",
    stroke: "#bce2ae",
    strokeWidth: 1.51
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M963,832L991,856L993,785Z",
    fill: "#1d7a41",
    stroke: "#1d7a41",
    strokeWidth: 1.51
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1137,656L1210,629L1183,605Z",
    fill: "#228445",
    stroke: "#228445",
    strokeWidth: 1.51
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M913,955L991,856L963,832Z",
    fill: "#1d743f",
    stroke: "#1d743f",
    strokeWidth: 1.51
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M846,-79L754,-98L772,-52Z",
    fill: "#b4dda8",
    stroke: "#b4dda8",
    strokeWidth: 1.51
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M186,607L278,700L250,544Z",
    fill: "#95c880",
    stroke: "#95c880",
    strokeWidth: 1.51
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1129,812L1133,726L993,785Z",
    fill: "#16773d",
    stroke: "#16773d",
    strokeWidth: 1.51
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1107,29L991,-24L1045,69Z",
    fill: "#98c48f",
    stroke: "#98c48f",
    strokeWidth: 1.51
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1045,69L991,-24L966,30Z",
    fill: "#9cca92",
    stroke: "#9cca92",
    strokeWidth: 1.51
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M940,-30L972,-144L846,-79Z",
    fill: "#a4d39e",
    stroke: "#a4d39e",
    strokeWidth: 1.51
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M171,331L193,381L233,370Z",
    fill: "#cbeaa0",
    stroke: "#cbeaa0",
    strokeWidth: 1.51
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M642,947L641,872L552,891Z",
    fill: "#4f8955",
    stroke: "#4f8955",
    strokeWidth: 1.51
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M642,947L735,948L641,872Z",
    fill: "#468552",
    stroke: "#468552",
    strokeWidth: 1.51
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M859,872L913,955L963,832Z",
    fill: "#217742",
    stroke: "#217742",
    strokeWidth: 1.51
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M558,994L642,947L552,891Z",
    fill: "#538b57",
    stroke: "#538b57",
    strokeWidth: 1.51
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M207,475L179,485L250,544Z",
    fill: "#acda90",
    stroke: "#acda90",
    strokeWidth: 1.51
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M193,381L179,485L207,475Z",
    fill: "#b8e198",
    stroke: "#b8e198",
    strokeWidth: 1.51
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1183,605L1245,553L1175,465Z",
    fill: "#30904e",
    stroke: "#30904e",
    strokeWidth: 1.51
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1175,756L1210,629L1137,656Z",
    fill: "#1b7c3f",
    stroke: "#1b7c3f",
    strokeWidth: 1.51
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M496,-19L367,2L422,70Z",
    fill: "#e3f4bc",
    stroke: "#e3f4bc",
    strokeWidth: 1.51
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M312,159L225,114L242,238Z",
    fill: "#e9f7ae",
    stroke: "#e9f7ae",
    strokeWidth: 1.51
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M407,-57L367,2L496,-19Z",
    fill: "#e5f4c0",
    stroke: "#e5f4c0",
    strokeWidth: 1.51
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1210,629L1245,553L1183,605Z",
    fill: "#248747",
    stroke: "#248747",
    strokeWidth: 1.51
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1279,226L1195,156L1188,263Z",
    fill: "#7cae6d",
    stroke: "#7cae6d",
    strokeWidth: 1.51
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1188,263L1195,156L1091,241Z",
    fill: "#7fb36f",
    stroke: "#7fb36f",
    strokeWidth: 1.51
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1281,302L1188,263L1196,336Z",
    fill: "#6ba766",
    stroke: "#6ba766",
    strokeWidth: 1.51
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M193,381L110,425L179,485Z",
    fill: "#bee39d",
    stroke: "#bee39d",
    strokeWidth: 1.51
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M212,306L171,331L233,370Z",
    fill: "#d1eca2",
    stroke: "#d1eca2",
    strokeWidth: 1.51
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M142,210L171,331L212,306Z",
    fill: "#ddf1a9",
    stroke: "#ddf1a9",
    strokeWidth: 1.51
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M142,210L212,306L242,238Z",
    fill: "#e2f4aa",
    stroke: "#e2f4aa",
    strokeWidth: 1.51
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1180,97L1107,29L1075,134Z",
    fill: "#91bd7f",
    stroke: "#91bd7f",
    strokeWidth: 1.51
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M425,1004L558,994L531,892Z",
    fill: "#5e8f5b",
    stroke: "#5e8f5b",
    strokeWidth: 1.51
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M531,892L558,994L552,891Z",
    fill: "#598d58",
    stroke: "#598d58",
    strokeWidth: 1.51
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M335,751L364,848L429,742Z",
    fill: "#77aa6a",
    stroke: "#77aa6a",
    strokeWidth: 1.51
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M281,823L364,848L335,751Z",
    fill: "#79a86b",
    stroke: "#79a86b",
    strokeWidth: 1.51
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M367,2L311,36L422,70Z",
    fill: "#eaf7bc",
    stroke: "#eaf7bc",
    strokeWidth: 1.51
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M851,991L879,961L859,872Z",
    fill: "#287945",
    stroke: "#287945",
    strokeWidth: 1.51
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M642,947L715,978L735,948Z",
    fill: "#428451",
    stroke: "#428451",
    strokeWidth: 1.51
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M558,994L715,978L642,947Z",
    fill: "#4c8753",
    stroke: "#4c8753",
    strokeWidth: 1.51
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M278,700L281,823L335,751Z",
    fill: "#80b070",
    stroke: "#80b070",
    strokeWidth: 1.51
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M179,485L186,607L250,544Z",
    fill: "#a3d58a",
    stroke: "#a3d58a",
    strokeWidth: 1.51
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M311,36L278,62L312,159Z",
    fill: "#eef9b7",
    stroke: "#eef9b7",
    strokeWidth: 1.51
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M311,36L207,6L278,62Z",
    fill: "#f3fac3",
    stroke: "#f3fac3",
    strokeWidth: 1.51
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M367,2L310,-75L311,36Z",
    fill: "#eff9c6",
    stroke: "#eff9c6",
    strokeWidth: 1.51
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M466,-123L407,-57L496,-19Z",
    fill: "#e1f3be",
    stroke: "#e1f3be",
    strokeWidth: 1.51
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1195,156L1180,97L1075,134Z",
    fill: "#8cb877",
    stroke: "#8cb877",
    strokeWidth: 1.51
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1129,812L1175,756L1133,726Z",
    fill: "#12743c",
    stroke: "#12743c",
    strokeWidth: 1.51
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M851,991L859,872L735,948Z",
    fill: "#317c48",
    stroke: "#317c48",
    strokeWidth: 1.51
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1133,726L1175,756L1137,656Z",
    fill: "#19793e",
    stroke: "#19793e",
    strokeWidth: 1.51
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1340,496L1285,510L1390,589Z",
    fill: "#2d844a",
    stroke: "#2d844a",
    strokeWidth: 1.51
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1129,812L993,785L991,856Z",
    fill: "#17753e",
    stroke: "#17753e",
    strokeWidth: 1.51
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M1190,822L1129,812L1133,914Z",
    fill: "#0c6636",
    stroke: "#0c6636",
    strokeWidth: 1.51
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M879,961L913,955L859,872Z",
    fill: "#257744",
    stroke: "#257744",
    strokeWidth: 1.51
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1285,510L1287,436L1175,465Z",
    fill: "#409455",
    stroke: "#409455",
    strokeWidth: 1.51
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1195,156L1259,52L1180,97Z",
    fill: "#8ab478",
    stroke: "#8ab478",
    strokeWidth: 1.51
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1285,510L1175,465L1245,553Z",
    fill: "#379151",
    stroke: "#379151",
    strokeWidth: 1.51
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M278,62L225,114L312,159Z",
    fill: "#f0f9b3",
    stroke: "#f0f9b3",
    strokeWidth: 1.51
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M715,978L761,995L735,948Z",
    fill: "#3c814e",
    stroke: "#3c814e",
    strokeWidth: 1.51
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M879,961L851,991L913,955Z",
    fill: "#257744",
    stroke: "#257744",
    strokeWidth: 1.51
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1313,668L1245,553L1210,629Z",
    fill: "#1e8043",
    stroke: "#1e8043",
    strokeWidth: 1.51
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1287,436L1281,302L1196,336Z",
    fill: "#5da05f",
    stroke: "#5da05f",
    strokeWidth: 1.51
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M645,-92L598,-150L611,-19Z",
    fill: "#cce9b4",
    stroke: "#cce9b4",
    strokeWidth: 1.51
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M754,-98L598,-150L645,-92Z",
    fill: "#c5e6b1",
    stroke: "#c5e6b1",
    strokeWidth: 1.51
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M972,-144L598,-150L754,-98Z",
    fill: "#b6dfa9",
    stroke: "#b6dfa9",
    strokeWidth: 1.51
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M761,995L851,991L735,948Z",
    fill: "#357e4b",
    stroke: "#357e4b",
    strokeWidth: 1.51
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M404,949L531,892L454,843Z",
    fill: "#64925e",
    stroke: "#64925e",
    strokeWidth: 1.51
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M715,978L535,1034L761,995Z",
    fill: "#468552",
    stroke: "#468552",
    strokeWidth: 1.51
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M211,746L281,823L278,700Z",
    fill: "#83b272",
    stroke: "#83b272",
    strokeWidth: 1.51
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M407,-57L310,-75L367,2Z",
    fill: "#ecf8c4",
    stroke: "#ecf8c4",
    strokeWidth: 1.51
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M105,97L160,168L225,114Z",
    fill: "#f6fcba",
    stroke: "#f6fcba",
    strokeWidth: 1.51
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M598,-150L466,-123L496,-19Z",
    fill: "#d9efba",
    stroke: "#d9efba",
    strokeWidth: 1.51
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M404,949L454,843L364,848Z",
    fill: "#6b9861",
    stroke: "#6b9861",
    strokeWidth: 1.51
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1281,302L1279,226L1188,263Z",
    fill: "#71a868",
    stroke: "#71a868",
    strokeWidth: 1.51
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1293,168L1279,226L1376,226Z",
    fill: "#78a56a",
    stroke: "#78a56a",
    strokeWidth: 1.51
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M167,679L211,746L278,700Z",
    fill: "#8cba77",
    stroke: "#8cba77",
    strokeWidth: 1.51
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M179,485L93,608L186,607Z",
    fill: "#a1d38d",
    stroke: "#a1d38d",
    strokeWidth: 1.51
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M186,607L167,679L278,700Z",
    fill: "#92c07b",
    stroke: "#92c07b",
    strokeWidth: 1.51
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M171,331L110,425L193,381Z",
    fill: "#c9e9a2",
    stroke: "#c9e9a2",
    strokeWidth: 1.51
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M82,328L110,425L171,331Z",
    fill: "#ceeba8",
    stroke: "#ceeba8",
    strokeWidth: 1.51
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M91,632L167,679L186,607Z",
    fill: "#98c684",
    stroke: "#98c684",
    strokeWidth: 1.51
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M225,114L160,168L242,238Z",
    fill: "#edf8b1",
    stroke: "#edf8b1",
    strokeWidth: 1.51
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M207,6L225,114L278,62Z",
    fill: "#f5fbc0",
    stroke: "#f5fbc0",
    strokeWidth: 1.51
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M466,-123L429,-119L407,-57Z",
    fill: "#e3f4bf",
    stroke: "#e3f4bf",
    strokeWidth: 1.51
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M152,-144L429,-119L466,-123Z",
    fill: "#edf8c4",
    stroke: "#edf8c4",
    strokeWidth: 1.51
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M160,168L142,210L242,238Z",
    fill: "#ebf7b0",
    stroke: "#ebf7b0",
    strokeWidth: 1.51
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M300,940L404,949L364,848Z",
    fill: "#709663",
    stroke: "#709663",
    strokeWidth: 1.51
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M846,-79L972,-144L754,-98Z",
    fill: "#abd9a3",
    stroke: "#abd9a3",
    strokeWidth: 1.51
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M991,-24L972,-144L940,-30Z",
    fill: "#a0ce9a",
    stroke: "#a0ce9a",
    strokeWidth: 1.51
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M997,-143L972,-144L991,-24Z",
    fill: "#9ecc98",
    stroke: "#9ecc98",
    strokeWidth: 1.51
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1128,-42L991,-24L1107,29Z",
    fill: "#97c291",
    stroke: "#97c291",
    strokeWidth: 1.51
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1205,-29L1128,-42L1107,29Z",
    fill: "#92bb8e",
    stroke: "#92bb8e",
    strokeWidth: 1.51
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1205,-29L1107,29L1180,97Z",
    fill: "#90b987",
    stroke: "#90b987",
    strokeWidth: 1.51
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1175,756L1265,716L1210,629Z",
    fill: "#15763d",
    stroke: "#15763d",
    strokeWidth: 1.51
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1129,812L1190,822L1175,756Z",
    fill: "#0b6e39",
    stroke: "#0b6e39",
    strokeWidth: 1.51
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1133,914L1129,812L991,856Z",
    fill: "#126938",
    stroke: "#126938",
    strokeWidth: 1.51
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1030,957L991,856L913,955Z",
    fill: "#1b6e3d",
    stroke: "#1b6e3d",
    strokeWidth: 1.51
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M984,1042L1030,957L913,955Z",
    fill: "#1b6e3d",
    stroke: "#1b6e3d",
    strokeWidth: 1.51
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1190,822L1265,716L1175,756Z",
    fill: "#0b6f39",
    stroke: "#0b6f39",
    strokeWidth: 1.51
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1110,-139L997,-143L991,-24Z",
    fill: "#9ac695",
    stroke: "#9ac695",
    strokeWidth: 1.51
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1287,436L1352,444L1281,302Z",
    fill: "#529659",
    stroke: "#529659",
    strokeWidth: 1.51
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1285,510L1340,496L1287,436Z",
    fill: "#3c8e52",
    stroke: "#3c8e52",
    strokeWidth: 1.51
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1390,589L1285,510L1245,553Z",
    fill: "#288549",
    stroke: "#288549",
    strokeWidth: 1.51
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1279,226L1293,168L1195,156Z",
    fill: "#7ead6e",
    stroke: "#7ead6e",
    strokeWidth: 1.51
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1376,226L1279,226L1281,302Z",
    fill: "#70a366",
    stroke: "#70a366",
    strokeWidth: 1.51
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M167,679L173,746L211,746Z",
    fill: "#8db979",
    stroke: "#8db979",
    strokeWidth: 1.51
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M211,746L166,839L281,823Z",
    fill: "#82ac71",
    stroke: "#82ac71",
    strokeWidth: 1.51
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M346,974L425,1004L404,949Z",
    fill: "#6b9561",
    stroke: "#6b9561",
    strokeWidth: 1.51
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M99,721L173,746L167,679Z",
    fill: "#8fba7d",
    stroke: "#8fba7d",
    strokeWidth: 1.51
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M429,-119L310,-75L407,-57Z",
    fill: "#eaf7c2",
    stroke: "#eaf7c2",
    strokeWidth: 1.51
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M69,261L171,331L142,210Z",
    fill: "#e2f3b0",
    stroke: "#e2f3b0",
    strokeWidth: 1.51
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M69,261L82,328L171,331Z",
    fill: "#daf0af",
    stroke: "#daf0af",
    strokeWidth: 1.51
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M65,479L93,608L179,485Z",
    fill: "#abd997",
    stroke: "#abd997",
    strokeWidth: 1.51
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1340,496L1352,444L1287,436Z",
    fill: "#408e53",
    stroke: "#408e53",
    strokeWidth: 1.51
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M558,994L535,1034L715,978Z",
    fill: "#518a56",
    stroke: "#518a56",
    strokeWidth: 1.51
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M761,995L972,1045L851,991Z",
    fill: "#287945",
    stroke: "#287945",
    strokeWidth: 1.51
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M425,1004L535,1034L558,994Z",
    fill: "#5e8f5b",
    stroke: "#5e8f5b",
    strokeWidth: 1.51
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1370,649L1313,668L1379,732Z",
    fill: "#126b39",
    stroke: "#126b39",
    strokeWidth: 1.51
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M1030,957L1133,914L991,856Z",
    fill: "#146638",
    stroke: "#146638",
    strokeWidth: 1.51
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M1265,716L1313,668L1210,629Z",
    fill: "#15763d",
    stroke: "#15763d",
    strokeWidth: 1.51
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M1340,496L1434,495L1352,444Z",
    fill: "#3a864f",
    stroke: "#3a864f",
    strokeWidth: 1.51
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1313,668L1265,716L1379,732Z",
    fill: "#0e6c39",
    stroke: "#0e6c39",
    strokeWidth: 1.51
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M65,479L179,485L110,425Z",
    fill: "#b8e09e",
    stroke: "#b8e09e",
    strokeWidth: 1.51
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M-10,346L65,479L110,425Z",
    fill: "#c3e6ab",
    stroke: "#c3e6ab",
    strokeWidth: 1.51
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M404,949L425,1004L531,892Z",
    fill: "#64925e",
    stroke: "#64925e",
    strokeWidth: 1.51
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M270,905L364,848L281,823Z",
    fill: "#77a069",
    stroke: "#77a069",
    strokeWidth: 1.51
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M62,114L69,261L142,210Z",
    fill: "#eef8bc",
    stroke: "#eef8bc",
    strokeWidth: 1.51
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M265,-81L207,6L311,36Z",
    fill: "#f5fbca",
    stroke: "#f5fbca",
    strokeWidth: 1.51
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1128,-42L1110,-139L991,-24Z",
    fill: "#97c291",
    stroke: "#97c291",
    strokeWidth: 1.51
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1293,168L1259,52L1195,156Z",
    fill: "#86b174",
    stroke: "#86b174",
    strokeWidth: 1.51
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M-39,564L91,632L93,608Z",
    fill: "#9fce94",
    stroke: "#9fce94",
    strokeWidth: 1.51
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M93,608L91,632L186,607Z",
    fill: "#9cca8a",
    stroke: "#9cca8a",
    strokeWidth: 1.51
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M166,839L211,746L173,746Z",
    fill: "#87b275",
    stroke: "#87b275",
    strokeWidth: 1.51
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M166,839L270,905L281,823Z",
    fill: "#7ca26c",
    stroke: "#7ca26c",
    strokeWidth: 1.51
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M82,328L-10,346L110,425Z",
    fill: "#cfebaf",
    stroke: "#cfebaf",
    strokeWidth: 1.51
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M62,114L142,210L160,168Z",
    fill: "#f2fabb",
    stroke: "#f2fabb",
    strokeWidth: 1.51
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M1259,52L1205,-29L1180,97Z",
    fill: "#8cb584",
    stroke: "#8cb584",
    strokeWidth: 1.51
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M270,905L300,940L364,848Z",
    fill: "#739965",
    stroke: "#739965",
    strokeWidth: 1.51
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M300,940L346,974L404,949Z",
    fill: "#709763",
    stroke: "#709763",
    strokeWidth: 1.51
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M310,-75L265,-81L311,36Z",
    fill: "#f2fac8",
    stroke: "#f2fac8",
    strokeWidth: 1.51
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M429,-119L265,-81L310,-75Z",
    fill: "#eef9c5",
    stroke: "#eef9c5",
    strokeWidth: 1.51
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M207,6L168,22L225,114Z",
    fill: "#f8fdc5",
    stroke: "#f8fdc5",
    strokeWidth: 1.51
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M194,-34L168,22L207,6Z",
    fill: "#fafdcf",
    stroke: "#fafdcf",
    strokeWidth: 1.51
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M1140,1035L1228,946L1133,914Z",
    fill: "#095d33",
    stroke: "#095d33",
    strokeWidth: 1.51
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M851,991L972,1045L913,955Z",
    fill: "#207541",
    stroke: "#207541",
    strokeWidth: 1.51
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M535,1034L972,1045L761,995Z",
    fill: "#39804c",
    stroke: "#39804c",
    strokeWidth: 1.51
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M972,1045L984,1042L913,955Z",
    fill: "#1d703e",
    stroke: "#1d703e",
    strokeWidth: 1.51
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M1172,-119L1110,-139L1128,-42Z",
    fill: "#92bc8e",
    stroke: "#92bc8e",
    strokeWidth: 1.51
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M997,-143L1110,-139L972,-144Z",
    fill: "#9bc795",
    stroke: "#9bc795",
    strokeWidth: 1.51
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M91,632L99,721L167,679Z",
    fill: "#93bf83",
    stroke: "#93bf83",
    strokeWidth: 1.51
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M270,905L265,1002L300,940Z",
    fill: "#769967",
    stroke: "#769967",
    strokeWidth: 1.51
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M87,844L99,721L-34,740Z",
    fill: "#8bb485",
    stroke: "#8bb485",
    strokeWidth: 1.51
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M168,22L105,97L225,114Z",
    fill: "#f9fcc2",
    stroke: "#f9fcc2",
    strokeWidth: 1.51
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M-7,77L62,114L105,97Z",
    fill: "#fbfdcc",
    stroke: "#fbfdcc",
    strokeWidth: 1.51
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M265,-81L194,-34L207,6Z",
    fill: "#f8fccd",
    stroke: "#f8fccd",
    strokeWidth: 1.51
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M1293,168L1380,51L1259,52Z",
    fill: "#85ab77",
    stroke: "#85ab77",
    strokeWidth: 1.51
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1259,52L1252,-31L1205,-29Z",
    fill: "#8cb48a",
    stroke: "#8cb48a",
    strokeWidth: 1.51
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M1392,288L1376,226L1281,302Z",
    fill: "#6b9c62",
    stroke: "#6b9c62",
    strokeWidth: 1.51
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M87,844L166,839L173,746Z",
    fill: "#86ad77",
    stroke: "#86ad77",
    strokeWidth: 1.51
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1426,372L1281,302L1352,444Z",
    fill: "#55945a",
    stroke: "#55945a",
    strokeWidth: 1.51
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M1426,372L1392,288L1281,302Z",
    fill: "#60975e",
    stroke: "#60975e",
    strokeWidth: 1.51
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M1313,668L1390,589L1245,553Z",
    fill: "#1e7c43",
    stroke: "#1e7c43",
    strokeWidth: 1.51
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M1379,732L1265,716L1315,867Z",
    fill: "#036435",
    stroke: "#036435",
    strokeWidth: 1.51
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M1370,649L1390,589L1313,668Z",
    fill: "#19733d",
    stroke: "#19733d",
    strokeWidth: 1.51
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M1205,-29L1172,-119L1128,-42Z",
    fill: "#90b98d",
    stroke: "#90b98d",
    strokeWidth: 1.51
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M1381,-8L1252,-31L1259,52Z",
    fill: "#88ae87",
    stroke: "#88ae87",
    strokeWidth: 1.51
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M1252,-31L1172,-119L1205,-29Z",
    fill: "#8eb68b",
    stroke: "#8eb68b",
    strokeWidth: 1.51
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M69,261L20,264L82,328Z",
    fill: "#e0f2b7",
    stroke: "#e0f2b7",
    strokeWidth: 1.51
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M65,479L-39,564L93,608Z",
    fill: "#a7d69c",
    stroke: "#a7d69c",
    strokeWidth: 1.51
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M62,114L20,264L69,261Z",
    fill: "#edf8bf",
    stroke: "#edf8bf",
    strokeWidth: 1.51
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M1434,495L1426,372L1352,444Z",
    fill: "#438852",
    stroke: "#438852",
    strokeWidth: 1.51
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M1430,198L1395,129L1376,226Z",
    fill: "#769c68",
    stroke: "#769c68",
    strokeWidth: 1.51
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M105,97L62,114L160,168Z",
    fill: "#f7fcc0",
    stroke: "#f7fcc0",
    strokeWidth: 1.51
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M109,-37L105,97L168,22Z",
    fill: "#fcfdd0",
    stroke: "#fcfdd0",
    strokeWidth: 1.51
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M1463,591L1434,495L1390,589Z",
    fill: "#237843",
    stroke: "#237843",
    strokeWidth: 1.51
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M1390,589L1434,495L1340,496Z",
    fill: "#2d8049",
    stroke: "#2d8049",
    strokeWidth: 1.51
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M20,264L-10,346L82,328Z",
    fill: "#dbf0b8",
    stroke: "#dbf0b8",
    strokeWidth: 1.51
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M-91,302L-10,346L20,264Z",
    fill: "#ddf1bc",
    stroke: "#ddf1bc",
    strokeWidth: 1.51
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M1463,675L1463,591L1390,589Z",
    fill: "#1a6d3c",
    stroke: "#1a6d3c",
    strokeWidth: 1.51
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M1315,867L1265,716L1190,822Z",
    fill: "#006636",
    stroke: "#006636",
    strokeWidth: 1.51
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M1228,946L1190,822L1133,914Z",
    fill: "#085d33",
    stroke: "#085d33",
    strokeWidth: 1.51
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M300,940L265,1002L346,974Z",
    fill: "#749866",
    stroke: "#749866",
    strokeWidth: 1.51
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M346,974L265,1002L425,1004Z",
    fill: "#709763",
    stroke: "#709763",
    strokeWidth: 1.51
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M425,1004L265,1002L535,1034Z",
    fill: "#699460",
    stroke: "#699460",
    strokeWidth: 1.51
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M186,1012L265,1002L270,905Z",
    fill: "#799a69",
    stroke: "#799a69",
    strokeWidth: 1.51
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M1140,1035L1133,914L1030,957Z",
    fill: "#106235",
    stroke: "#106235",
    strokeWidth: 1.51
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M1376,226L1395,129L1293,168Z",
    fill: "#7aa26b",
    stroke: "#7aa26b",
    strokeWidth: 1.51
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M1430,198L1376,226L1392,288Z",
    fill: "#6f9a63",
    stroke: "#6f9a63",
    strokeWidth: 1.51
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M1461,289L1392,288L1426,372Z",
    fill: "#5e915b",
    stroke: "#5e915b",
    strokeWidth: 1.51
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M1461,289L1430,198L1392,288Z",
    fill: "#6a9560",
    stroke: "#6a9560",
    strokeWidth: 1.51
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M984,1042L1140,1035L1030,957Z",
    fill: "#146638",
    stroke: "#146638",
    strokeWidth: 1.51
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M1166,1046L1140,1035L984,1042Z",
    fill: "#106235",
    stroke: "#106235",
    strokeWidth: 1.51
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M1228,946L1315,867L1190,822Z",
    fill: "#015b32",
    stroke: "#015b32",
    strokeWidth: 1.51
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M1289,962L1315,867L1228,946Z",
    fill: "#00552f",
    stroke: "#00552f",
    strokeWidth: 1.51
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M166,839L135,903L270,905Z",
    fill: "#7e9f6d",
    stroke: "#7e9f6d",
    strokeWidth: 1.51
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M87,844L135,903L166,839Z",
    fill: "#82a475",
    stroke: "#82a475",
    strokeWidth: 1.51
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M87,844L173,746L99,721Z",
    fill: "#8ab37d",
    stroke: "#8ab37d",
    strokeWidth: 1.51
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M152,-144L109,-37L194,-34Z",
    fill: "#fcfdd3",
    stroke: "#fcfdd3",
    strokeWidth: 1.51
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M194,-34L109,-37L168,22Z",
    fill: "#fcfdd2",
    stroke: "#fcfdd2",
    strokeWidth: 1.51
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M-34,740L99,721L91,632Z",
    fill: "#93bd89",
    stroke: "#93bd89",
    strokeWidth: 1.51
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M1523,385L1461,289L1426,372Z",
    fill: "#578d58",
    stroke: "#578d58",
    strokeWidth: 1.51
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M1252,-31L1300,-131L1172,-119Z",
    fill: "#8cb48a",
    stroke: "#8cb48a",
    strokeWidth: 1.51
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M1395,129L1380,51L1293,168Z",
    fill: "#81a570",
    stroke: "#81a570",
    strokeWidth: 1.51
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M1421,43L1380,51L1395,129Z",
    fill: "#81a175",
    stroke: "#81a175",
    strokeWidth: 1.51
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M1381,-8L1380,51L1421,43Z",
    fill: "#83a37e",
    stroke: "#83a37e",
    strokeWidth: 1.51
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M-10,346L-50,442L65,479Z",
    fill: "#c3e6b1",
    stroke: "#c3e6b1",
    strokeWidth: 1.51
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M-124,409L-50,442L-10,346Z",
    fill: "#c9e8b3",
    stroke: "#c9e8b3",
    strokeWidth: 1.51
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M-35,166L20,264L62,114Z",
    fill: "#f2fac7",
    stroke: "#f2fac7",
    strokeWidth: 1.51
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M-53,482L-39,564L65,479Z",
    fill: "#b1dca6",
    stroke: "#b1dca6",
    strokeWidth: 1.51
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M1463,675L1390,589L1370,649Z",
    fill: "#176d3b",
    stroke: "#176d3b",
    strokeWidth: 1.51
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M1434,495L1523,385L1426,372Z",
    fill: "#478652",
    stroke: "#478652",
    strokeWidth: 1.51
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M1463,675L1370,649L1379,732Z",
    fill: "#106637",
    stroke: "#106637",
    strokeWidth: 1.51
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M-50,442L-53,482L65,479Z",
    fill: "#b9e1ac",
    stroke: "#b9e1ac",
    strokeWidth: 1.51
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M972,1045L1166,1046L984,1042Z",
    fill: "#156739",
    stroke: "#156739",
    strokeWidth: 1.51
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M1140,1035L1166,1046L1228,946Z",
    fill: "#085c32",
    stroke: "#085c32",
    strokeWidth: 1.51
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M1403,806L1379,732L1315,867Z",
    fill: "#005b32",
    stroke: "#005b32",
    strokeWidth: 1.51
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M1403,806L1429,739L1379,732Z",
    fill: "#055d33",
    stroke: "#055d33",
    strokeWidth: 1.51
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M-7,77L-35,166L62,114Z",
    fill: "#fafdce",
    stroke: "#fafdce",
    strokeWidth: 1.51
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M-93,524L-39,564L-53,482Z",
    fill: "#aedaa5",
    stroke: "#aedaa5",
    strokeWidth: 1.51
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M1349,920L1403,806L1315,867Z",
    fill: "#00522e",
    stroke: "#00522e",
    strokeWidth: 1.51
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M1290,1045L1289,962L1228,946Z",
    fill: "#00552f",
    stroke: "#00552f",
    strokeWidth: 1.51
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M1380,51L1381,-8L1259,52Z",
    fill: "#85a880",
    stroke: "#85a880",
    strokeWidth: 1.51
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M1421,43L1395,129L1489,144Z",
    fill: "#7e9d6e",
    stroke: "#7e9d6e",
    strokeWidth: 1.51
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M1429,739L1463,675L1379,732Z",
    fill: "#0c6034",
    stroke: "#0c6034",
    strokeWidth: 1.51
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M1524,612L1463,675L1540,715Z",
    fill: "#136537",
    stroke: "#136537",
    strokeWidth: 1.51
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M265,1002L186,1012L535,1034Z",
    fill: "#729764",
    stroke: "#729764",
    strokeWidth: 1.51
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M135,903L186,1012L270,905Z",
    fill: "#7c9c6c",
    stroke: "#7c9c6c",
    strokeWidth: 1.51
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M103,963L186,1012L135,903Z",
    fill: "#7e9d71",
    stroke: "#7e9d71",
    strokeWidth: 1.51
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M265,-81L152,-144L194,-34Z",
    fill: "#f9fcce",
    stroke: "#f9fcce",
    strokeWidth: 1.51
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M109,-37L-7,77L105,97Z",
    fill: "#fcfed4",
    stroke: "#fcfed4",
    strokeWidth: 1.51
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M429,-119L152,-144L265,-81Z",
    fill: "#f3fac9",
    stroke: "#f3fac9",
    strokeWidth: 1.51
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M598,-150L152,-144L466,-123Z",
    fill: "#e7f5c1",
    stroke: "#e7f5c1",
    strokeWidth: 1.51
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M-39,-18L-7,77L109,-37Z",
    fill: "#ffffe1",
    stroke: "#ffffe1",
    strokeWidth: 1.51
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M-87,547L-52,643L-39,564Z",
    fill: "#a2d19c",
    stroke: "#a2d19c",
    strokeWidth: 1.51
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M-39,564L-52,643L91,632Z",
    fill: "#9fcc99",
    stroke: "#9fcc99",
    strokeWidth: 1.51
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M87,844L103,963L135,903Z",
    fill: "#7f9d75",
    stroke: "#7f9d75",
    strokeWidth: 1.51
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M1489,144L1395,129L1430,198Z",
    fill: "#789a68",
    stroke: "#789a68",
    strokeWidth: 1.51
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M1361,-95L1300,-131L1252,-31Z",
    fill: "#88ad87",
    stroke: "#88ad87",
    strokeWidth: 1.51
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M1172,-119L1300,-131L1110,-139Z",
    fill: "#8fb78c",
    stroke: "#8fb78c",
    strokeWidth: 1.51
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M1361,-95L1252,-31L1381,-8Z",
    fill: "#87aa86",
    stroke: "#87aa86",
    strokeWidth: 1.51
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M-110,174L-67,211L-35,166Z",
    fill: "#f2fac8",
    stroke: "#f2fac8",
    strokeWidth: 1.51
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M-35,166L-67,211L20,264Z",
    fill: "#eef8c5",
    stroke: "#eef8c5",
    strokeWidth: 1.51
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M-93,524L-87,547L-39,564Z",
    fill: "#a9d8a1",
    stroke: "#a9d8a1",
    strokeWidth: 1.51
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M1289,962L1349,920L1315,867Z",
    fill: "#00512d",
    stroke: "#00512d",
    strokeWidth: 1.51
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M1566,454L1434,495L1463,591Z",
    fill: "#2f7c48",
    stroke: "#2f7c48",
    strokeWidth: 1.51
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M1566,454L1523,385L1434,495Z",
    fill: "#408350",
    stroke: "#408350",
    strokeWidth: 1.51
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M1569,204L1489,144L1430,198Z",
    fill: "#759966",
    stroke: "#759966",
    strokeWidth: 1.51
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M-93,524L-53,482L-124,409Z",
    fill: "#b8e0ab",
    stroke: "#b8e0ab",
    strokeWidth: 1.51
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M-67,211L-91,302L20,264Z",
    fill: "#e6f5c1",
    stroke: "#e6f5c1",
    strokeWidth: 1.51
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M-124,409L-53,482L-50,442Z",
    fill: "#bee3af",
    stroke: "#bee3af",
    strokeWidth: 1.51
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M-108,666L-34,740L-52,643Z",
    fill: "#95c090",
    stroke: "#95c090",
    strokeWidth: 1.51
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M-52,643L-34,740L91,632Z",
    fill: "#97c291",
    stroke: "#97c291",
    strokeWidth: 1.51
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M16,869L103,963L87,844Z",
    fill: "#809e79",
    stroke: "#809e79",
    strokeWidth: 1.51
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M1569,204L1430,198L1461,289Z",
    fill: "#6e9662",
    stroke: "#6e9662",
    strokeWidth: 1.51
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M1469,-57L1381,-8L1421,43Z",
    fill: "#82a081",
    stroke: "#82a081",
    strokeWidth: 1.51
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M1469,-57L1361,-95L1381,-8Z",
    fill: "#83a283",
    stroke: "#83a283",
    strokeWidth: 1.51
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M-34,740L16,869L87,844Z",
    fill: "#87ac84",
    stroke: "#87ac84",
    strokeWidth: 1.51
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M1463,675L1524,612L1463,591Z",
    fill: "#186c3b",
    stroke: "#186c3b",
    strokeWidth: 1.51
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M1540,715L1463,675L1429,739Z",
    fill: "#0c5f34",
    stroke: "#0c5f34",
    strokeWidth: 1.51
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M1483,814L1429,739L1403,806Z",
    fill: "#005630",
    stroke: "#005630",
    strokeWidth: 1.51
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M-91,302L-124,409L-10,346Z",
    fill: "#d3edb8",
    stroke: "#d3edb8",
    strokeWidth: 1.51
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M-93,524L-108,666L-87,547Z",
    fill: "#a3d29d",
    stroke: "#a3d29d",
    strokeWidth: 1.51
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M-110,174L-124,409L-91,302Z",
    fill: "#dff2bd",
    stroke: "#dff2bd",
    strokeWidth: 1.51
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M1566,454L1550,300L1523,385Z",
    fill: "#508955",
    stroke: "#508955",
    strokeWidth: 1.51
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M1523,385L1550,300L1461,289Z",
    fill: "#5c8e5a",
    stroke: "#5c8e5a",
    strokeWidth: 1.51
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M1478,908L1483,814L1403,806Z",
    fill: "#004e2c",
    stroke: "#004e2c",
    strokeWidth: 1.51
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M1289,962L1400,1029L1349,920Z",
    fill: "#004e2c",
    stroke: "#004e2c",
    strokeWidth: 1.51
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M1166,1046L1290,1045L1228,946Z",
    fill: "#035931",
    stroke: "#035931",
    strokeWidth: 1.51
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M1524,612L1566,454L1463,591Z",
    fill: "#257743",
    stroke: "#257743",
    strokeWidth: 1.51
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M1569,204L1519,131L1489,144Z",
    fill: "#779a68",
    stroke: "#779a68",
    strokeWidth: 1.51
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M1489,144L1519,131L1421,43Z",
    fill: "#7e9c6e",
    stroke: "#7e9c6e",
    strokeWidth: 1.51
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M-7,77L-110,174L-35,166Z",
    fill: "#f8fccd",
    stroke: "#f8fccd",
    strokeWidth: 1.51
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M152,-144L60,-135L109,-37Z",
    fill: "#fdfed8",
    stroke: "#fdfed8",
    strokeWidth: 1.51
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M-87,547L-108,666L-52,643Z",
    fill: "#9ecb98",
    stroke: "#9ecb98",
    strokeWidth: 1.51
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M-34,740L-79,782L16,869Z",
    fill: "#89b089",
    stroke: "#89b089",
    strokeWidth: 1.51
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M-124,409L-108,666L-93,524Z",
    fill: "#acd9a3",
    stroke: "#acd9a3",
    strokeWidth: 1.51
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M-121,28L-110,174L-7,77Z",
    fill: "#fcfed3",
    stroke: "#fcfed3",
    strokeWidth: 1.51
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M-67,211L-110,174L-91,302Z",
    fill: "#ebf7c3",
    stroke: "#ebf7c3",
    strokeWidth: 1.51
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M1524,612L1565,634L1566,454Z",
    fill: "#217642",
    stroke: "#217642",
    strokeWidth: 1.51
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1478,908L1403,806L1349,920Z",
    fill: "#004b2b",
    stroke: "#004b2b",
    strokeWidth: 1.51
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M60,-135L-39,-18L109,-37Z",
    fill: "#fefee0",
    stroke: "#fefee0",
    strokeWidth: 1.51
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M-108,666L-79,782L-34,740Z",
    fill: "#90b98d",
    stroke: "#90b98d",
    strokeWidth: 1.51
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M16,869L51,999L103,963Z",
    fill: "#809d7a",
    stroke: "#809d7a",
    strokeWidth: 1.51
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M1483,814L1540,715L1429,739Z",
    fill: "#055a31",
    stroke: "#055a31",
    strokeWidth: 1.51
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M1540,715L1565,634L1524,612Z",
    fill: "#156738",
    stroke: "#156738",
    strokeWidth: 1.51
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M-40,958L51,999L16,869Z",
    fill: "#819e80",
    stroke: "#819e80",
    strokeWidth: 1.51
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M103,963L51,999L186,1012Z",
    fill: "#7f9d74",
    stroke: "#7f9d74",
    strokeWidth: 1.51
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1550,300L1569,204L1461,289Z",
    fill: "#68935f",
    stroke: "#68935f",
    strokeWidth: 1.51
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M1566,454L1569,204L1550,300Z",
    fill: "#5d8f5a",
    stroke: "#5d8f5a",
    strokeWidth: 1.51
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1576,836L1569,204L1566,454Z",
    fill: "#337d4a",
    stroke: "#337d4a",
    strokeWidth: 1.51
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M1551,27L1507,11L1519,131Z",
    fill: "#7f9d77",
    stroke: "#7f9d77",
    strokeWidth: 1.51
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1519,131L1507,11L1421,43Z",
    fill: "#7f9d76",
    stroke: "#7f9d76",
    strokeWidth: 1.51
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1361,-95L1570,-122L1300,-131Z",
    fill: "#83a182",
    stroke: "#83a182",
    strokeWidth: 1.51
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1507,11L1469,-57L1421,43Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M-79,782L-64,863L16,869Z",
    fill: "#86a986",
    stroke: "#86a986",
    strokeWidth: 1.51
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M-72,958L-64,863L-126,1046Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M1456,1006L1478,908L1349,920Z",
    fill: "#004629",
    stroke: "#004629",
    strokeWidth: 1.51
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M1483,814L1576,836L1540,715Z",
    fill: "#005630",
    stroke: "#005630",
    strokeWidth: 1.51
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M1469,-57L1482,-77L1361,-95Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M1507,11L1482,-77L1469,-57Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1570,-122L1482,-77L1507,11Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M1290,1045L1400,1029L1289,962Z",
    fill: "#00502d",
    stroke: "#00502d",
    strokeWidth: 1.51
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M-114,-10L-121,28L-39,-18Z",
    fill: "#ffffe5",
    stroke: "#ffffe5",
    strokeWidth: 1.51
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M-39,-18L-121,28L-7,77Z",
    fill: "#fefee0",
    stroke: "#fefee0",
    strokeWidth: 1.51
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M-110,174L-121,28L-124,409Z",
    fill: "#eff9c6",
    stroke: "#eff9c6",
    strokeWidth: 1.51
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M1569,204L1551,27L1519,131Z",
    fill: "#7d9c6c",
    stroke: "#7d9c6c",
    strokeWidth: 1.51
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M-64,863L-40,958L16,869Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M-112,-76L-114,-10L-39,-18Z",
    fill: "#ffffe5",
    stroke: "#ffffe5",
    strokeWidth: 1.51
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M60,-135L-52,-136L-39,-18Z",
    fill: "#ffffe5",
    stroke: "#ffffe5",
    strokeWidth: 1.51
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M152,-144L-52,-136L60,-135Z",
    fill: "#fefedf",
    stroke: "#fefedf",
    strokeWidth: 1.51
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1400,1029L1456,1006L1349,920Z",
    fill: "#00482a",
    stroke: "#00482a",
    strokeWidth: 1.51
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M1478,908L1576,836L1483,814Z",
    fill: "#004c2c",
    stroke: "#004c2c",
    strokeWidth: 1.51
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M1540,715L1576,836L1565,634Z",
    fill: "#095d33",
    stroke: "#095d33",
    strokeWidth: 1.51
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M-64,863L-72,958L-40,958Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M-40,958L-18,1030L51,999Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M-126,1046L-64,863L-79,782Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M-72,958L-18,1030L-40,958Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M51,999L-18,1030L186,1012Z",
    fill: "#809d78",
    stroke: "#809d78",
    strokeWidth: 1.51
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M186,1012L-18,1030L535,1034Z",
    fill: "#799a69",
    stroke: "#799a69",
    strokeWidth: 1.51
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M535,1034L-126,1046L972,1045Z",
    fill: "#64915d",
    stroke: "#64915d",
    strokeWidth: 1.51
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M1565,634L1576,836L1566,454Z",
    fill: "#16693a",
    stroke: "#16693a",
    strokeWidth: 1.51
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1571,947L1576,836L1478,908Z",
    fill: "#004529",
    stroke: "#004529",
    strokeWidth: 1.51
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M-52,-136L-112,-76L-39,-18Z",
    fill: "#ffffe5",
    stroke: "#ffffe5",
    strokeWidth: 1.51
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M-114,-10L-112,-76L-121,28Z",
    fill: "#ffffe5",
    stroke: "#ffffe5",
    strokeWidth: 1.51
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1456,1006L1571,947L1478,908Z",
    fill: "#004529",
    stroke: "#004529",
    strokeWidth: 1.51
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1482,-77L1570,-122L1361,-95Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1300,-131L1570,-122L1110,-139Z",
    fill: "#87ab86",
    stroke: "#87ab86",
    strokeWidth: 1.51
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1551,27L1570,-122L1507,11Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1569,204L1570,-122L1551,27Z",
    fill: "#809d7a",
    stroke: "#809d7a",
    strokeWidth: 1.51
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1576,836L1570,-122L1569,204Z",
    fill: "#60905c",
    stroke: "#60905c",
    strokeWidth: 1.51
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M1456,1006L1547,1048L1571,947Z",
    fill: "#004529",
    stroke: "#004529",
    strokeWidth: 1.51
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1400,1029L1547,1048L1456,1006Z",
    fill: "#004529",
    stroke: "#004529",
    strokeWidth: 1.51
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1290,1045L1547,1048L1400,1029Z",
    fill: "#00472a",
    stroke: "#00472a",
    strokeWidth: 1.51
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1166,1046L1547,1048L1290,1045Z",
    fill: "#004f2d",
    stroke: "#004f2d",
    strokeWidth: 1.51
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M-126,1046L1547,1048L1166,1046Z",
    fill: "#287945",
    stroke: "#287945",
    strokeWidth: 1.51
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M-72,958L-126,1046L-18,1030Z",
    fill: "#819e81",
    stroke: "#819e81",
    strokeWidth: 1.51
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M-18,1030L-126,1046L535,1034Z",
    fill: "#7e9d72",
    stroke: "#7e9d72",
    strokeWidth: 1.51
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M972,1045L-126,1046L1166,1046Z",
    fill: "#468552",
    stroke: "#468552",
    strokeWidth: 1.51
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M-108,666L-126,1046L-79,782Z",
    fill: "#87aa86",
    stroke: "#87aa86",
    strokeWidth: 1.51
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M-124,409L-126,1046L-108,666Z",
    fill: "#93bd8f",
    stroke: "#93bd8f",
    strokeWidth: 1.51
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglify);
export default __webpack_public_path__ + "static/media/trianglify.b34aa25bfd732d541affcda349af8f3d.svg";
export { ForwardRef as ReactComponent };